export const UTILITIES = Object.freeze([
  {
    id: 'brand_parking',
    slug: 'brand_parking',
    labels: { en: 'Brand parking', pt: 'Estacionamento da marca' },
    synonyms: {
      en: ['exhibitor parking', 'brand-only parking'],
      pt: ['estacionamento de expositores', 'parque da marca'],
    },
  },
  {
    id: 'visitor_parking',
    slug: 'visitor_parking',
    labels: { en: 'Visitor parking', pt: 'Estacionamento para visitantes' },
    synonyms: {
      en: ['guest parking'],
      pt: ['parque de visitantes'],
    },
  },
  {
    id: 'loading_zone',
    slug: 'loading_zone',
    labels: { en: 'Loading zone', pt: 'Zona de cargas e descargas' },
    synonyms: {
      en: ['load-in area', 'loading bay'],
      pt: ['carga e descarga', 'baía de carga'],
    },
  },
  {
    id: 'power_supply',
    slug: 'power_supply',
    labels: { en: 'Power supply', pt: 'Fornecimento de energia' },
    synonyms: {
      en: ['electricity', 'outlets', 'mains power'],
      pt: ['eletricidade', 'tomadas'],
    },
  },
  {
    id: 'wifi_access',
    slug: 'wifi_access',
    labels: { en: 'Wi-Fi access', pt: 'Acesso Wi-Fi' },
    synonyms: {
      en: ['internet', 'wireless'],
      pt: ['internet', 'rede sem fios'],
    },
  },
  {
    id: 'toilets',
    slug: 'toilets',
    labels: { en: 'Toilets', pt: 'Casas de banho' },
    synonyms: {
      en: ['restrooms', 'WC'],
      pt: ['WC', 'instalações sanitárias'],
    },
  },
  {
    id: 'accessible_facilities',
    slug: 'accessible_facilities',
    labels: { en: 'Accessible facilities', pt: 'Instalações acessíveis' },
    synonyms: {
      en: ['wheelchair access', 'accessible'],
      pt: ['acessibilidade', 'acesso para cadeira de rodas'],
    },
  },
  {
    id: 'shaded_areas',
    slug: 'shaded_areas',
    labels: { en: 'Shaded areas', pt: 'Zonas com sombra' },
    synonyms: {
      en: ['shade'],
      pt: ['sombra'],
    },
  },
  {
    id: 'rest_zones',
    slug: 'rest_zones',
    labels: { en: 'Rest zones', pt: 'Zonas de descanso' },
    synonyms: {
      en: ['rest area', 'lounge'],
      pt: ['área de descanso', 'lounge'],
    },
  },
  {
    id: 'water_stations',
    slug: 'water_stations',
    labels: { en: 'Water stations', pt: 'Pontos de água' },
    synonyms: {
      en: ['water points', 'hydration'],
      pt: ['fontes de água', 'hidratação'],
    },
  },
  {
    id: 'security_staff',
    slug: 'security_staff',
    labels: { en: 'Security staff', pt: 'Equipa de segurança' },
    synonyms: {
      en: ['security'],
      pt: ['segurança no local'],
    },
  },
  {
    id: 'first_aid',
    slug: 'first_aid',
    labels: { en: 'First aid', pt: 'Primeiros socorros' },
    synonyms: {
      en: ['medical aid', 'nurse'],
      pt: ['apoio médico'],
    },
  },
  {
    id: 'fire_safety',
    slug: 'fire_safety',
    labels: { en: 'Fire safety', pt: 'Segurança contra incêndios' },
    synonyms: {
      en: ['fire extinguishers', 'fire exits'],
      pt: ['extintores', 'saídas de emergência'],
    },
  },
  {
    id: 'lost_and_found',
    slug: 'lost_and_found',
    labels: { en: 'Lost & found', pt: 'Achados e perdidos' },
    synonyms: {
      en: ['lost property'],
      pt: ['perdidos e achados'],
    },
  },
  {
    id: 'atm_station',
    slug: 'atm_station',
    labels: { en: 'ATM station', pt: 'Multibanco' },
    synonyms: {
      en: ['cash machine', 'ATM'],
      pt: ['caixa multibanco', 'MB'],
    },
  },
  {
    id: 'info_desk',
    slug: 'info_desk',
    labels: { en: 'Info desk', pt: 'Balcão de informações' },
    synonyms: {
      en: ['information desk', 'help desk'],
      pt: ['balcão de apoio', 'informações'],
    },
  },
  {
    id: 'kids_zone',
    slug: 'kids_zone',
    labels: { en: 'Kids zone', pt: 'Zona infantil' },
    synonyms: {
      en: ['children area'],
      pt: ['área infantil'],
    },
  },
  {
    id: 'food_court',
    slug: 'food_court',
    labels: { en: 'Food court', pt: 'Área de restauração' },
    synonyms: {
      en: ['food area', 'restaurants'],
      pt: ['restauração', 'praça de alimentação'],
    },
  },
  {
    id: 'recycling_bins',
    slug: 'recycling_bins',
    labels: { en: 'Recycling bins', pt: 'Ecopontos' },
    synonyms: {
      en: ['recycling'],
      pt: ['reciclagem', 'contentores de reciclagem'],
    },
  },
  {
    id: 'stand_furniture',
    slug: 'stand_furniture',
    labels: { en: 'Stand furniture', pt: 'Mobiliário de stand' },
    synonyms: {
      en: ['booth furniture'],
      pt: ['mobília de stand', 'mobiliário de exposição'],
    },
  },
  {
    id: 'cleaning_service',
    slug: 'cleaning_service',
    labels: { en: 'Cleaning service', pt: 'Serviço de limpeza' },
    synonyms: {
      en: ['cleaners', 'janitorial'],
      pt: ['limpeza'],
    },
  },
  {
    id: 'sound_system',
    slug: 'sound_system',
    labels: { en: 'Sound system', pt: 'Sistema de som' },
    synonyms: {
      en: ['PA system', 'audio'],
      pt: ['PA', 'áudio'],
    },
  },
  {
    id: 'storage_space',
    slug: 'storage_space',
    labels: { en: 'Storage space', pt: 'Espaço de armazenamento' },
    synonyms: {
      en: ['storage', 'warehouse'],
      pt: ['arrumos', 'armazenamento'],
    },
  },
  {
    id: 'charging_stations',
    slug: 'charging_stations',
    labels: { en: 'Charging stations', pt: 'Pontos de carregamento' },
    synonyms: {
      en: ['device charging', 'charging points'],
      pt: ['carregamento de dispositivos', 'postos de carregamento'],
    },
  },
  {
    id: 'smoking_area',
    slug: 'smoking_area',
    labels: { en: 'Smoking area', pt: 'Zona de fumadores' },
    synonyms: {
      en: ['smokers area'],
      pt: ['área de fumadores'],
    },
  },
  {
    id: 'coat_check_or_lockers',
    slug: 'coat_check_or_lockers',
    labels: { en: 'Coat check or lockers', pt: 'Chapelaria ou cacifos' },
    synonyms: {
      en: ['cloakroom', 'lockers'],
      pt: ['chapelaria', 'cacifos'],
    },
  },
  {
    id: 'changing_rooms',
    slug: 'changing_rooms',
    labels: { en: 'Changing rooms', pt: 'Balneários' },
    synonyms: {
      en: ['locker rooms', 'dress rooms'],
      pt: ['vestiários', 'salas de mudança'],
    },
  },
]);

// Alias if your code sometimes refers to them as "amenities"
export const AMENITIES = UTILITIES;

// Fast lookup map
export const utilitiesById = Object.freeze(
  UTILITIES.reduce((acc, u) => {
    acc[u.id] = u;
    return acc;
  }, {})
);

// Helpers
const normalizeLocale = (locale) =>
  String(locale).toLowerCase().startsWith('pt') ? 'pt' : 'en';

export function getUtilityLabel(id, locale = 'en') {
  const u = utilitiesById[id];
  if (!u) return '';
  const lang = normalizeLocale(locale);
  return u.labels[lang] || u.labels.en || '';
}

export function getUtilitiesLabels(locale = 'en') {
  const lang = normalizeLocale(locale);
  return UTILITIES.map((u) => ({
    id: u.id,
    label: u.labels[lang] || u.labels.en,
  }));
}

// Optional: IDs array for quick validation / forms
export const UTILITY_IDS = Object.freeze(UTILITIES.map((u) => u.id));

export default UTILITIES;
